<!-- 运营中心 费用上报-->
<template>
  <div>
    <div class="search">
      <el-form :inline="true" style="padding-top:0px;margin-top:20px" :model="searchForm" class="searchForm"
        size="medium">
        <el-form-item label="月份:">
          <label slot="label">月&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;份：</label>
          <el-date-picker size="medium" v-model="searchForm.month" type="month" value-format="yyyy-MM" placeholder="选择日期" clearable>
          </el-date-picker>
        </el-form-item>
        <el-form-item label="部门：">
          <label slot="label">部&nbsp;&nbsp;&nbsp;&nbsp;门：</label>
          <el-select size="medium" filterable v-model="searchForm.PROJECT" placeholder="请选择" clearable>
            <el-option v-for="item in points" :key="item.value" :label="item.DEPARTMENT_NAME" :value="item.ID">
              <!-- <span style="float: left">{{ item.NAME }}</span> -->
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="费用大类：">
          <el-select size="medium" filterable v-model="searchForm.FIST_TYPE" placeholder="请选择" @change="chanegFistType"
            style="width:100%" clearable>
            <el-option v-for="item in firstTypes" :key="item.value" :label="item.FIRST_RF_TYPE_NAME"
              :value="item.FIRST_RF_TYPE_ID">
              <!-- <span style="float: left">{{ item.NAME }}</span> -->
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="费用二类：">
          <el-select size="medium" filterable v-model="searchForm.SECOND_TYPE" placeholder="请选择" style="width:100%" clearable>
            <el-option v-for="item in secondTypes" :key="item.value" :label="item.SECOND_RF_TYPE_NAME"
              :value="item.SECOND_RF_TYPE_ID">
              <!-- <span style="float: left">{{ item.NAME }}</span> -->
            </el-option>
          </el-select>
        </el-form-item>
        <el-row style="padding-top:10px;padding-bottom:10px">
          <el-button size="medium" @click="serch()" type="primary">筛选</el-button>
          <el-button type="text" size="medium" style="color: #409EFF" @click="clearSearch()">重置筛选条件</el-button>
          <el-button size="medium" @click="gotoCategoryCost" type="primary" style="float: right;">费用类型管理</el-button>
        </el-row>
      </el-form>
    </div>
    <el-row class="middle">
      <el-button size="medium" @click="addDish()" type="primary">上报费用</el-button>
    </el-row>
    <el-row style="padding: 15px 20px;background:white;border-radius:3px">

      <el-table stripe border :data="tableData" :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }">
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column label="部门" prop="DEPARTMENT_NAME"></el-table-column>
        <el-table-column label="金额" prop="REPORT_FEE"></el-table-column>
        <el-table-column label="费用类别" prop="FIRST_RF_TYPE_NAME"></el-table-column>
        <el-table-column label="费用二类" prop="SECOND_RF_TYPE_NAME"></el-table-column>
        <el-table-column label="备注" prop="COMMENT"></el-table-column>
        <el-table-column label="分期" prop="CURRENT_PROGRESS"></el-table-column>
        <el-table-column label="费用日期" prop="MONTH"></el-table-column>
        <!-- <el-table-column label="上报部门" prop="PROJECT_CODE"></el-table-column> -->
        <!-- <el-table-column label="上报人" prop="ADDITION_PERSON_NAME"></el-table-column> -->
        <el-table-column label="产生时间" prop="PRODUCE_TIME"></el-table-column>
        <el-table-column label="操作" prop="PROJECT_NAME">
          <template slot-scope="scope">
            <el-button type="text" @click="update(scope.row)">修改</el-button>
            <el-button type="text" @click="delData(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <el-pagination style="text-align: right" @current-change="handleCurrentChange" :current-page.sync="currentPage"
        :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="total_count">
      </el-pagination>
    </el-row>
    <el-dialog title="新增费用上报" center :visible.sync="addFormVisible" width="650px">
      <el-form ref="addForm" v-model="addForm" :label-width="'150px'" :inline="true">
        <el-form-item label="部门">
          <label slot="label">部&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;门：</label>
          <el-select filterable v-model="addForm.PROJECT_ID" placeholder="请选择" clearable style="width:350px"
            @change="chanegProject">
            <el-option v-for="item in projects" :key="item.value" :label="item.DEPARTMENT_NAME" :value="item.ID">
              <!-- <span style="float: left">{{ item.NAME }}</span> -->
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="月份:">
          <label slot="label">月&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;份：</label>
          <el-date-picker style="width:350px" v-model="addForm.MONTH" type="month" value-format="yyyy-MM"
            placeholder="选择日期" :clearable='false'>
          </el-date-picker>
        </el-form-item>

        <el-form-item label="费用大类：">
          <el-select filterable v-model="addForm.FIST_TYPE" placeholder="请选择" @change="chanegFistType"
            style="width:350px">
            <el-option v-for="item in firstType" :key="item.value" :label="item.FIRST_RF_TYPE_NAME"
              :value="item.FIRST_RF_TYPE_ID">
              <!-- <span style="float: left">{{ item.NAME }}</span> -->
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="费用二类：">
          <el-select filterable v-model="addForm.SECOND_TYPE_ID" placeholder="请选择" style="width:350px"
            @change="changeSecondType">
            <el-option v-for="item in secondType" :key="item.value" :label="item.SECOND_RF_TYPE_NAME"
              :value="item.SECOND_RF_TYPE_ID">
              <!-- <span style="float: left">{{ item.NAME }}</span> -->
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="金额：">
          <el-input v-model="addForm.REPORT_FEE" style="width:350px"></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input v-model="addForm.COMMENT" style="width:350px"></el-input>
        </el-form-item>
        <el-form-item label="分期时长：" v-show="this.MULTIPLE === 0">
          <el-input v-model="addForm.STAGES" style="width:350px"> <span slot="append">期</span></el-input>
        </el-form-item>
        <el-form-item label="产生时间：" prop="TIME" v-show="this.MULTIPLE === 1">
          <el-date-picker v-model="addForm.TIME" type="date" placeholder="选择日期" style="width:350px">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close()">取消</el-button>
        <el-button @click="submitContract()">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="分期" center :visible.sync="installmentFormVisible" width="600px">
      <el-form :model="installmentForm" ref="installmentForm" :label-width="formLabelWidth" :rules="rule">
        <el-form-item label="分期时长：" prop="STAGES_LENGTH">
          <el-input v-model="installmentForm.STAGES_LENGTH">
            <template slot="append">期</template>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取消</el-button>
        <el-button @click="submitSeparate()" v-show="this.status === 1">确定</el-button>
        <el-button @click="submitSeparate()" v-show="this.status === 0" disabled>确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改费用上报" center :visible.sync="editFormVisible" width="600px">
      <el-form :model="addForm" ref="editForm" :label-width="formLabelWidth">
        <el-form-item label="部门：">
          <el-input v-model="editForm.DEPARTMENT_NAME" disabled></el-input>
        </el-form-item>
        <el-form-item label="费用月份：">
          <el-date-picker v-model="editForm.MONTH" type="month" value-format="yyyy-MM" placeholder="选择日期"
            :clearable='false' style="width:100%" disabled>
          </el-date-picker>
        </el-form-item>
        <el-form-item label="费用类别：">
          <el-input v-model="editForm.FIRST_RF_TYPE_NAME" disabled></el-input>
        </el-form-item>
        <el-form-item label="二级类别：">
          <el-input v-model="editForm.SECOND_RF_TYPE_NAME" disabled></el-input>
        </el-form-item>
        <el-form-item label="金额：">
          <el-input v-model="editForm.REPORT_FEE"></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input v-model="editForm.COMMENT"></el-input>
        </el-form-item>
        <div v-show="this.editForm.BE_MULTIPLE_DATA === 0">
          <el-form-item label="分期时长：">
            <el-input v-model="editForm.ALL_PROGRESS">
              <template slot="append">期</template>
            </el-input>
          </el-form-item>
        </div>
        <div v-show="this.editForm.BE_MULTIPLE_DATA === 1">
          <el-form-item label="产生时间：">
            <el-date-picker v-model="editForm.PRODUCE_TIME" type="date" placeholder="选择日期" style="width:100%">
            </el-date-picker>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取消</el-button>
        <el-button @click="submitUpdate()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import http from '@/assets/common/http';
import date from '@/assets/common/date';

export default {
  data() {
    return {
      searchForm: {
        project: '',
        SECOND_TYPE: '',
      },
      firstTypes: [],
      firstType: [],
      secondTypes: [],
      secondType: [],
      MULTIPLE: '',
      currentPage: 1,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      total_count: 0,
      points: [],
      addFormVisible: false,
      addForm: {
        SECOND_TYPE_ID: '',
      },
      installmentForm: {},
      installmentFormVisible: false,
      editFormVisible: false,
      editForm: {},
      formLabelWidth: '100px',
      meals: [],
      tableData: [
      ],
      rule: {
        STAGES_LENGTH: [{ required: true, message: '请输入分期时长', trigger: 'blur' }],
      },
      status: '',
      showStatus: ['拒绝', '待审核', '审核通过'],
      modifyForm: {},

      modifyVisible: false,
      currentRow: {},
      mealMsg: [],
      projects: [],
      loading1: false,
    };
  },
  computed: {
  },
  created() {
    this.queryProject();
    this.queryProjects();
    // this.queryFirstType()
    this.queryFirstTypes();
    this.queryList();
  },
  methods: {
    clearSearch() {
      this.searchForm = {};
    },
    batchReport() {
      this.$router.push({ path: '/financialBatchReport' });
    },
    // 获取项目点
    queryProject() {
      const params = {
        GYS_ID: sessionStorage.getItem('tcId'),
        SERVICE_ID: '10048',
        OTYPE: 5,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
      };
      http.post(params).then((result) => {
        this.points = result;
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    queryProjects() {
      const params = {
        GYS_ID: sessionStorage.getItem('tcId'),
        SERVICE_ID: '10048',
        OTYPE: 5,
        USER_ID: sessionStorage.getItem('userId'),
        STATUS: 1,
        SESSION: sessionStorage.getItem('session'),
      };
      http.post(params).then((result) => {
        this.projects = result;
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    // 审核
    checkStatus(row, status) {
      const params = {
        TC_ID: sessionStorage.getItem('companyId'),
        SERVICE_ID: '10041',
        OTYPE: 20,
        RECORD_ID: row.RECORD_ID,
        BE_MULTIPLE_DATA: row.BE_MULTIPLE_DATA,
        STATUS: status,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.queryList();
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },


    // 分期
    separate(row) {
      this.installmentForm = row;
      this.installmentFormVisible = true;
      this.status = row.BE_MULTIPLE_DATA;
    },
    submitSeparate() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            TC_ID: this.installmentForm.TC_ID,
            SERVICE_ID: '10041',
            OTYPE: 11,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            RECORD_ID: this.installmentForm.RECORD_ID,
            STAGES_LENGTH: this.installmentForm.STAGES_LENGTH,
          };
          if (!this.installmentForm.STAGES_LENGTH) {
            this.$message.show({
              text: '请输入分期时长',
              type: 'warning',
            });
            return false;
          }
          http.post(params).then((result) => {
            this.$message.show({
              text: '分期成功',
              type: 'success',
            });
            this.installmentFormVisible = false;
            this.queryList();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({
              text: error,
              type: 'error',
            });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    chanegProject(e) {
      this.addForm.FIST_TYPE = '';
      this.queryFirstType(e);
    },
    //  拉取类别
    queryFirstType(index) {
      const params = {
        SERVICE_ID: '10064',
        OTYPE: 4,
        USER_ID: parseInt(sessionStorage.getItem('userId')),
        SESSION: sessionStorage.getItem('session'),
        GYS_ID: sessionStorage.getItem('tcId'),
        DEPARTMENT_ID: index,
      };
      http.post(params).then((result) => {
        if (result.length == 0) {
          this.firstType = [];
        } else {
          this.firstType = result[0].RF_LIST;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    chanegFistType(e) {
      this.searchForm.SECOND_TYPE = '';
      this.addForm.SECOND_TYPE_ID = '';
      if (e !== '') {
        this.querySecondType(e);
        this.querySecondTypes(e);
      } else {
        this.secondType = [];
        this.searchForm.SECOND_TYPE = '';
      }
    },
    changeSecondType(e) {
      let obj = {};
      obj = this.secondType.find((item) => item.SECOND_RF_TYPE_ID === e);
      this.MULTIPLE = obj.BE_MULTIPLE_DATA;
    },
    querySecondType(index) {
      const params = {
        SERVICE_ID: '10064',
        OTYPE: 9,
        USER_ID: parseInt(sessionStorage.getItem('userId')),
        SESSION: sessionStorage.getItem('session'),
        FIRST_TYPE_ID: index,
      };
      http.post(params).then((result) => {
        if (result.length == 0) {
          this.secondType = [];
        } else {
          this.secondType = result[0].RF_LIST;
        }

        // this.queryList()
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    querySecondTypes(index) {
      const params = {
        SERVICE_ID: '10064',
        OTYPE: 9,
        USER_ID: parseInt(sessionStorage.getItem('userId')),
        SESSION: sessionStorage.getItem('session'),
        FIRST_TYPE_ID: index,
        ALL: 1,
      };
      http.post(params).then((result) => {
        if (result.length == 0) {
          this.secondTypes = [];
        } else {
          this.secondTypes = result[0].RF_LIST;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryFirstTypes() {
      const params = {
        SERVICE_ID: '10064',
        OTYPE: 4,
        USER_ID: parseInt(sessionStorage.getItem('userId')),
        SESSION: sessionStorage.getItem('session'),
        GYS_ID: sessionStorage.getItem('tcId'),
        ALL: 1,
      };
      http.post(params).then((result) => {
        if (result.length == 0) {
          this.firstTypes = [];
        } else {
          this.firstTypes = result[0].RF_LIST;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryList();
    },
    queryList() {
      const params = {
        SERVICE_ID: '10064',
        OTYPE: 12,
        USER_ID: parseInt(sessionStorage.getItem('userId')),
        SESSION: sessionStorage.getItem('session'),
        PAGE_SIZE: this.pageSize,
        PAGE_INDEX: this.currentPage - 1,
        GYS_ID: sessionStorage.getItem('tcId'),
      };
      if (this.searchForm.month) {
        params.MONTH = this.searchForm.month;
      }
      if (this.searchForm.PROJECT) {
        params.DEPARTMENT_ID = this.searchForm.PROJECT;
      }

      if (this.searchForm.FIST_TYPE) {
        params.FIRST_TYPE_ID = this.searchForm.FIST_TYPE;
      }
      if (this.searchForm.SECOND_TYPE) {
        params.SECOND_RF_TYPE_ID = this.searchForm.SECOND_TYPE;
      }
      http.post(params).then((result) => {
        if (result.length !== 0) {
          this.total_count = result[0].TOTAL_COUNT;
          this.tableData = result[0].RF_LIST;
        } else {
          this.tableData = [];
          this.$message.show({ text: '暂无数据', type: 'warning' });
          return false;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 删除
    delData(row) {
      this.$confirm('您确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          SERVICE_ID: '10064',
          OTYPE: 14,
          USER_ID: sessionStorage.getItem('userId'),
          SESSION: sessionStorage.getItem('session'),
          // TC_ID: Number(sessionStorage.getItem('companyId')),
          RECORD_ID: row.RECORD_ID,
        };
        http.post(params).then((result) => {
          this.$message.show({ text: '删除成功', type: 'success' });
          this.queryList();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }).catch(() => {
        this.$message.show({
          type: 'info',
          text: '取消操作',
        });
      });
    },
    // 修改
    update(row) {
      this.editFormVisible = true;
      this.editForm = row;
    },
    submitUpdate() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10064',
            OTYPE: 13,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            REPORT_FEE: this.editForm.REPORT_FEE,
            COMMENT: this.editForm.COMMENT,
            RECORD_ID: this.editForm.RECORD_ID,
          };
          const reg = /^(\-|\+)?\d+(\.\d+)?$/;
          if (!reg.test(this.editForm.REPORT_FEE)) {
            this.$message.show({ text: '请输入正确的金额', type: 'warning' });
            document.body.style.cursor = 'default';
            return false;
          }
          if (Number(this.editForm.REPORT_FEE)) {
            if (Number(this.editForm.REPORT_FEE) > 99999999.99) {
              this.$message.show({ text: '金额太大无法上报,请修改', type: 'warning' });
              return false;
            }
          }
          http.post(params).then((result) => {
            this.editFormVisible = false;
            this.queryList();
            this.$message.show({ text: '修改成功', type: 'success' });
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    // 新增
    addDish() {
      this.addFormVisible = true;
    },
    submitContract() {
      const params = {
        SERVICE_ID: '10064',
        OTYPE: 11,
        USER_ID: parseInt(sessionStorage.getItem('userId')),
        SESSION: sessionStorage.getItem('session'),
        MONTH: this.addForm.MONTH,
        SECOND_TYPE_ID: this.addForm.SECOND_TYPE_ID,
        REPORT_FEE: this.addForm.REPORT_FEE,
        BE_MULTIPLE_DATA: this.MULTIPLE,
      };
      if (this.addForm.COMMENT) {
        params.COMMENT = this.addForm.COMMENT;
      } else {
        params.COMMENT = '';
      }
      if (this.addForm.STAGES) {
        const reg = /^[0-9]*[1-9][0-9]*$/;
        if (!reg.test(this.addForm.STAGES)) {
          this.$message.show({ text: '请输入正确的分期时长', type: 'warning' });
          return false;
        }
      }
      if (!this.addForm.STAGES && !this.addForm.TIME) {
        this.$message.show({ text: '请输入分期时长或产生时间', type: 'warning' });
        return false;
      }
      if (this.MULTIPLE == 0) {
        params.STAGES_LENGTH = this.addForm.STAGES;
      }
      if (this.MULTIPLE == 1) {
        if (this.addForm.TIME) {
          params.PRODUCE_TIME = date(this.addForm.TIME, '%F');
        }
      }
      if (this.addForm.REPORT_FEE) {
        if (Number(this.addForm.REPORT_FEE) > 99999999.99) {
          this.$message.show({ text: '金额太大无法上报,请修改', type: 'warning' });
          return false;
        }
        const reg = /^(\-|\+)?\d+(\.\d+)?$/;
        if (!reg.test(this.addForm.REPORT_FEE)) {
          this.$message.show({ text: '请输入正确的金额', type: 'warning' });
          return false;
        }
      }
      if (!this.addForm.PROJECT_ID || !this.addForm.MONTH || !this.addForm.SECOND_TYPE_ID || !this.addForm.REPORT_FEE) {
        this.$message.show({ text: '请输入所有必填信息', type: 'warning' });
        document.body.style.cursor = 'default';
        return false;
      }
      http.post(params).then((result) => {
        this.$message.show({ text: '新增成功', type: 'success' });
        this.queryList();
        this.addFormVisible = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    close() {
      this.addFormVisible = false;
      this.installmentFormVisible = false;
      this.editFormVisible = false;
      this.queryList();
    },
    serch() {
      this.currentPage = 1;
      this.queryList();
    },
    gotoCategoryCost() {
      this.$router.push({ path: '/categoryCost/detail' });
    },
  },
};

</script>
<style scoped>
.pagination_box {
  float: right;
  margin-top: 10px;
}

.qualificatLoad {
  font-size: 14px;
  color: #606266;
}

.middle {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #f5f7f9;
  padding: 0 40px;
  margin: 0 -20px 0 -20px;
}

.search {
  width: 100%;
}

.searchForm {
  background: white;
  border-radius: 3px;
  padding: 20px 20px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/operationCenter/costReport.vue